import React, { useRef, useEffect, useState } from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend,CategoryScale } from "chart.js/auto";
import { Doughnut } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend);

const DonutChart = ({data,height,serviceColors}) => {

  
  const [storeCount,setStoreCount]=useState()
  const [serviceNames,setServiceNames]=useState()
  const [color,setColor]=useState()
  
  useEffect(() => {
   let dataCount= []
   let serviceName = []
   data.map((d) => {
    dataCount.push(d.store_count)
    serviceName.push(d.service_name)
   })
   setStoreCount(dataCount)
   setServiceNames(serviceName)
}, [data])


useEffect(() => {
 if(serviceColors !== undefined){
  let colorValues = []
  Object.entries(serviceColors).map((key,value)=> {
    let val = key[1].color
     colorValues.push(val)
  })

  setColor(colorValues)
 }
 
}, [serviceColors])


  const Doughnutdata = {
    type   : 'RoundedDoughnut',
    labels: serviceNames,
    datasets: [
      {
        label: 'no of Stores',
        data: storeCount,
        backgroundColor: color,
        borderColor:color,
        borderWidth: 1,
      },
    ],
  }

  const options = {
    elements: {
      arc: {
          borderWidth: 18,
          
      },
  },
  cutoutPercentage: 70,
  // percentageInnerCutout: 10,
   cutout: "80%",
       // borderRadius: 10,
        responsive: true,
    plugins: {
      legend: {
        display: false, // Hide dataset labels
      },
      layout:{
        padding:40
      }, 
    },
    maintainAspectRatio: false, // Make the chart responsive
    responsive: true, // Enable responsiveness
    
  };
  

  return (
  <div class="w-75">
  <Doughnut data={Doughnutdata} options={options} style={{height:"370px",width:"100%"}}/>
  </div>
  )
};

export default DonutChart;